(function($, undefined) {
	
	'use strict';
	var popupUtil;
	var editLabelBtn;
	var editLabelPopup;
	var saveLabelBtn;
	
	var openEditLabelPopup = function(e) {
		e.stopPropagation();
		var btn = $(this);
		var label = btn.attr('data-label');
		var currentValue = btn.attr('data-label-value');
		
		editLabelPopup.find('input[name=value]').val(currentValue);
		editLabelPopup.find('input[name=label]').val(label);
		popupUtil.openPopupById(editLabelPopup.attr('id'));
	};
	
	var saveLabel = function() {
		var popup = $(this).closest('.popup-outer');
		popup.find('.has-processing').addClass('processing');
		var newValue = popup.find('input[name=value]').val();
		var label = popup.find('input[name=label]').val();
		
		updateLabel(label, newValue, 'fr', function() {
			location.reload();
		});
	};
	
	var init = function () {
		popupUtil = Fw.component.models().popup;
		editLabelPopup = $('#edit-label-popup');
		editLabelBtn = $('.edit-label-btn');
		saveLabelBtn = $('.save-label-btn', editLabelPopup);
		
		editLabelBtn.on('click', openEditLabelPopup);
		saveLabelBtn.on('click', saveLabel);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
